import { defaultChainId, isSupportedChain, SupportedChainId } from 'config/chains'
import { useCallback, useMemo } from 'react'
import { useCloseModal } from 'state/application/hooks'
import { ApplicationModal } from 'state/application/reducer'
import { useChainId, useConnection as useWagmiConnection, useDisconnect, usePublicClient, useWalletClient } from 'wagmi'

/**
 * useConnection returns an object containing the connected account, the chainId that the app is currently
 * connected to, a disconnect function, and the wagmi clients (publicClient and walletClient).
 * The disconnect function will close the wallet modal and disconnect appkit.
 */
export function useConnection() {
  const { address, isConnected, isDisconnected, status } = useWagmiConnection()

  const wagmiChainId = useChainId()
  const wagmiPublicClient = usePublicClient()
  const { data: wagmiWalletClient } = useWalletClient()
  const { disconnect: _disconnect } = useDisconnect()
  const close = useCloseModal(ApplicationModal.WALLET)
  const disconnect = useCallback(() => {
    close()
    _disconnect()
  }, [_disconnect, close])

  const isUnsupportedChain = useMemo(() => {
    return !isSupportedChain(wagmiChainId)
  }, [wagmiChainId])

  //TODO: handle this better, app should know override happened
  const usedChainId = useMemo(
    () => (isUnsupportedChain ? defaultChainId() : wagmiChainId) as SupportedChainId,
    [isUnsupportedChain, wagmiChainId]
  )

  return {
    account: address,
    chainId: usedChainId,
    disconnect,
    wagmiPublicClient,
    wagmiWalletClient,
    initialized: true, // wagmi is always initialized once mounted
    isConnected,
    isDisconnected,
    isConnectionSettling: status === 'connecting' || status === 'reconnecting',
  }
}
